import React from 'react';

export const Video = ({ src = '', poster = '', ...props }) => (
  <video
    autoPlay
    muted
    playsInline
    controls
    src={src}
    poster={poster}
    width="100%"
    {...props}
  />
);
